import React from 'react'
import { Link } from 'react-router'
import {  Table } from 'reactstrap';
import Valid from 'react-icons/lib/md/check'
import NoValid from 'react-icons/lib/md/clear'


export default class ProfileSkills extends React.Component {

	renderResponsive(){
		const { provider, specialties} = this.props;

		const td_specialties = specialties.list.map((spe) => {
			if(provider.specialties.indexOf(spe.id) !== -1)
				var name = (<td> {spe.name} </td>);

            var tr = spe.skills.map((skill) => {
                if(provider.skills.indexOf(skill.id) !== -1)
                    return <div key={skill.id} className="item-skill skill-active"> {skill.name}</div>
            });
            return(
            	<Table className="table-skill" key={spe.id}>
                  <tbody>
                      <tr className="first">
                        {name}
                      </tr>
                      <tr>
                        <td>
                            {tr}
                        </td>
                      </tr>
                  </tbody>
            	</Table>
            )
        });

        return(
        	<div>
           		{td_specialties}
            </div>
		)
	}

	renderDesktop(){
		const { provider, specialties} = this.props;

        const td_specialties = specialties.list.map((spe) => {
            if(provider.specialties.indexOf(spe.id) !== -1)
                return <td key={spe.id}> {spe.name}</td>
            else
                return <td key={spe.id}>{}</td>
        });

        const td_skills = specialties.list.map((specialty) => {

            var td = specialty.skills.map((skill) => {
                if(provider.skills.indexOf(skill.id) !== -1)
                    return <div key={skill.id} className="item-skill skill-active"> {skill.name}</div>
            });

            return <td key={specialty.id}>{td}</td>
        });

		return(
            <Table className="table-skill">
                <tbody>
                      <tr className="first">
                        {td_specialties}
                      </tr>
                      <tr>
                         {td_skills}
                      </tr>
                </tbody>
            </Table>
		)
	}

	render(){

		return(
			<div >
				<div className="title-bloc">
	                Compétences
	            </div>

	            {this.props.responsive && this.renderResponsive()}
	            {!this.props.responsive && this.renderDesktop()}

			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/provider/components/profile/ProfileSkills.js